module.exports = __webpack_public_path__ + "static/media/maf-01.40583186.png";